export default class ScriptLoader {

	constructor()
	{
		this.loading = [];
		this.loaded = [];
	}

	load(url, callback, multiple = false)
	{

		if (this.isLoading(url) && !multiple) {
			return;
		}

		if (this.isLoaded(url)) {
			return callback();
		}

		this.loading.push(url);

		let documentTag = document, tag = 'script',
			object = documentTag.createElement(tag),
			scriptTag = documentTag.getElementsByTagName(tag)[0];

		object.src = 'https://' + url;

		object.addEventListener('load', (e) => {
			this.loaded.push(url);
			this.loading.splice(this.loading.indexOf(url), 1);
			callback();
		}, false);

		scriptTag.parentNode.insertBefore(object, scriptTag);
	}

	isLoading(script)
	{
		return this.loading.indexOf(script) >= 0;
	}

	isLoaded(script)
	{
		return this.loaded.indexOf(script) >= 0;
	}

}